import { camelCaseToSpaces } from './camel-case-to-space';
import { isDefined } from './is-defined';
import { resolveSchemaWithRef } from './resolve-schema-with-ref';
export const getOneOfSchemaList = (oneOfList, definitions = {}) => {
    const list = oneOfList
        .filter((oneOfSchema) => !isDefined(oneOfSchema.not))
        .map((schema, index) => {
        var _a, _b;
        const resolvedSchema = resolveSchemaWithRef(schema, definitions);
        let name = resolvedSchema.title;
        let description = resolvedSchema.description;
        const schemaProps = Object.keys((_a = resolvedSchema.properties) !== null && _a !== void 0 ? _a : {});
        const isSinglePropertySchema = schemaProps.length === 1;
        if (isSinglePropertySchema) {
            const singlePropertySchema = resolveSchemaWithRef(resolvedSchema.properties[schemaProps[0]], definitions);
            name !== null && name !== void 0 ? name : (name = (_b = singlePropertySchema.title) !== null && _b !== void 0 ? _b : camelCaseToSpaces(schemaProps[0], { capitalize: true }));
            description !== null && description !== void 0 ? description : (description = singlePropertySchema.description);
        }
        name !== null && name !== void 0 ? name : (name = `Schema ${index}`);
        return { name, description, schema: resolvedSchema };
    });
    if (list.length === 2) {
        const [firstSchema, secondSchema] = list;
        if (firstSchema.schema.type === 'string' && secondSchema.schema.type === 'object') {
            firstSchema.name = 'Simple';
            secondSchema.name = 'Advanced';
        }
    }
    return list;
};
//# sourceMappingURL=get-oneof-schema-list.js.map